{
  "version": 1,
  "asset_id": "9c4d8034-6a02-442c-a11d-a17c050ed7e3",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/9c4d8034-6a02-442c-a11d-a17c050ed7e3/gallery-3.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/9c4d8034-6a02-442c-a11d-a17c050ed7e3/gallery-3.jpeg",
  "original_filename": "gallery-3.jpeg",
  "size": 826570,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:36Z"
}
